exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".left-menu[data-v-47a5a0d4]{top:6rem;padding-bottom:2rem;width:14rem;left:calc(50% - 33rem)}", ""]);

// exports
